export default {
  state: {
    selectedSignalsGroup: null,
    selectedInstance: null,
    disabledInstances: [],
    disabledGroups: [],
  },
  mutations: {
    /**
     * this sets if a group has been selected (a group is selected when the mouse is hover on the UI)
     * when a group is selected, the others are temporary hidden in the UI (until a mouseout event on the selected group happens)
     */
    setSelectedSignalsGroup(state, group) {
      state.selectedSignalsGroup = group;
    },
    /**
     * this sets if an instance has been selected (an instance is selected when the mouse is hover on the UI)
     * when an instance is selected, the others are temporary hidden in the UI (until a mouseout event on the selected instance happens)
     */
    setSelectedInstance(state, instance) {
      state.selectedInstance = instance;
    },
    /**
     * this sets if an instance has been enabled (an instance is enaled when its toggle is switched ON)
     * when an instance is disabled it is permanently hidden from the UI
     */
    setInstanceEnabled(state, params) {
      params.instance.enabled = params.value;
      const instanceIdx = state.disabledInstances.findIndex(
        (idx) => idx === params.instance.id,
      );
      if (params.value && instanceIdx > -1) {
        state.disabledInstances.splice(instanceIdx, 1);
      }
      if (!params.value && instanceIdx === -1) {
        state.disabledInstances.push(params.instance.id);
      }
    },
    /**
     * this sets if a group has been enabled (a group is enaled when its toggle is switched ON)
     * when a group is disabled its instances are permanently hidden from the UI
     */
    setDisabledGroup(state, params) {
      params.group.enabled = params.value;
      const groupIdx = state.disabledGroups.findIndex(
        (idx) => idx === params.group.signalKey,
      );
      if (params.value && groupIdx > -1) {
        state.disabledGroups.splice(groupIdx, 1);
      }
      if (!params.value && groupIdx === -1) {
        state.disabledGroups.push(params.group.signalKey);
      }
    },
  },
  getters: {
    getSelectedSignalsGroup: (state) => {
      return state.selectedSignalsGroup;
    },
    getSelectedInstance: (state) => {
      return state.selectedInstance;
    },
    getDisabledInstances: (state) => {
      return state.disabledInstances;
    },
    getDisabledGroups: (state) => {
      return state.disabledGroups;
    },
  },
};
